import { USD } from './constants';
import moment from 'moment';

export function getProductPriceDetails(plan, isSubscriptionActive) {
  const priceAmount = plan?.unit_amount ?? 0;
  const priceCurrency = plan?.currency ?? USD;
  const isRecurring = plan?.recurring;

  const product = plan?.product;

  // Map price nickname to human-readable name using a lookup table
  const priceName = product?.name ?? '';
  const priceId = plan?.id ?? 'unknown';
  const status = plan?.status ?? 'unknown';
  // Calculate formatted price with currency handling
  const formattedPrice = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: priceCurrency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(priceAmount / 100);

  return {
    price: formattedPrice,
    currency: priceCurrency,
    priceName,
    priceId,
    status,
    isRecurring,
    isFree: priceAmount == 0 && !isSubscriptionActive,
    productMetadata: product?.metadata,
    features: product?.marketing_features,
  };
}

export const formatDate = unixTimestamp => {
  if (!unixTimestamp) return null;

  return moment.unix(unixTimestamp).format('D MMMM');
};
